import { faArrowLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { startTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import Faq from 'src/components/Faq/Faq';

export default function Faqs() {
  const navigate = useNavigate();
  const sampleFAQ = [
    {
      id: 1,
      question: 'What is 4DPS?',
      answer:
        '4DPS is a dynamic platform that offers comprehensive DSP (Demand-Side Platform) services, allowing businesses to efficiently manage and optimize their digital advertising campaigns. It provides tools to assign Digital Assets (DAs) to campaigns, enabling precise targeting and ad performance monitoring, similar to leading platforms like Amazon.',
    },
    {
      id: 2,
      question: 'How does 4DPS help in managing digital assets?',
      answer:
        '4DPS offers a streamlined process for assigning Digital Assets (DAs) to specific campaigns. This ensures that your digital assets, such as images, videos, and banners, are effectively utilized to drive performance and maximize ROI in your ad campaigns.',
    },
    {
      id: 3,
      question: 'What types of DSP services are offered on the platform?',
      answer:
        '4DPS offers a range of DSP services including audience targeting, real-time bidding, campaign optimization, and detailed analytics. These services are designed to help businesses reach their target audience with precision and improve the overall effectiveness of their advertising strategies.',
    },
    {
      id: 4,
      question: 'Can 4DPS be used for all types of businesses?',
      answer:
        'Yes, 4DPS is a versatile platform suitable for a wide range of businesses, from small startups to large enterprises. Its flexible tools and features make it ideal for businesses of all sizes looking to enhance their digital advertising efforts.',
    },
    {
      id: 5,
      question: 'Is there a customer support team available?',
      answer:
        'Absolutely! 4DPS offers dedicated customer support to assist with any issues or inquiries. Our team is available 24/7 to help you optimize your campaigns and ensure that your experience with our platform is seamless.',
    },
  ];

  return (
    <div className="my-3  position-relative">
      <FontAwesomeIcon
        onClick={() =>
          startTransition(() => {
            navigate(-1);
          })
        }
        icon={faXmark}
        color="white"
        className="position-absolute "
        size="xl"
        style={{ right: '25%', top: '1rem' }}
      />
      <div className="d-flex flex-column justify-content-center align-items-center w-100">
        <img className="faq-logo" src="4DSPS_White.png" alt="logo" />
        <h2 className="text-white">FAQs</h2>
        <p className="text-white mb-2">Your questions answered here.</p>
      </div>
      {sampleFAQ.map((faq, index) => (
        <div
          key={faq.id}
          className="d-flex flex-column justify-content-center align-content-center"
        >
          <Faq {...faq} />
          {index !== sampleFAQ.length - 1 && <div className="divider" />}
        </div>
      ))}
    </div>
  );
}
